<template>
  <div class="earnings-figures" @click="transClass($event)">
    <OverviewCard></OverviewCard>
    <!-- <IndexPageTable :closePop="closePop"></IndexPageTable> -->
    <masking v-if="!isDeveloper" style="padding: 0 0 200px"></masking>
  </div>
</template>

<script>
import Masking from '@/components/Masking';
import OverviewCard from './components/incomeData/overviewCard';
// import IndexPageTable from './components/incomeData/indexPageTable';
import { mapState } from 'vuex';
export default {
  name: 'EarningsFigures',
  components: {
    OverviewCard,
    // IndexPageTable,
    Masking,
  },
  data() {
    return {
      closePop: 0,
    };
  },
  mounted() {
    this.Report('view', 'BeneficialDataPage');
  },
  methods: {
    transClass(e) {
      if (e.target.className == 'th-title' || e.target.className == 'th-img') {
        return false;
      } else {
        this.closePop = Math.random();
      }
    },
  },
  computed: {
    ...mapState(['developerInfo']),
    isDeveloper() {
      return [1, 2].includes(this.developerInfo.state);
    },
  },
};
</script>
